export const LocalFeatureFlags = {
  ai_assistant: true,
  api_payload_export: true,
  catalog: true,
  decorator_profile: false,
  embeddable_viewer: true,
  lifestyle_image: true,
  local_settings: true,
  org_management: true,
  textura_viewer_setup: false,
  use_stitches_decals: true,
  api_keys_usage_ui: true,
  api_usage_billing_tier: true,
};
